import { connect } from 'react-redux';
import { withRenderFlag } from '@beef/react';
import { compose } from '@beef/redux';
import { Flex } from '@fttb/common/components';
import { hasTariffBenefts, withTariffBenefitsMapper } from "../../../../store/blocks/tariffs/benefitSelectors";
var mapStateToProps = function mapStateToProps(state) {
  return {
    shouldRender: !!hasTariffBenefts(state)
  };
};
export var TariffBenefitsGrid = compose(connect(mapStateToProps), withTariffBenefitsMapper, withRenderFlag)(Flex);